import { datadogRum } from '@datadog/browser-rum'

import { DD_SERVICE } from '../constants'

import { onRouteChange } from './routeChange'

export default function DatadogRumPlugin({ app, store }) {
  if (!app.$config.DD_RUM_ENABLED) {
    return
  }

  datadogRum.init({
    clientToken: app.$config.DD_RUM_CLIENT_TOKEN,
    applicationId: app.$config.DD_RUM_APPLICATION_ID,
    sampleRate: app.$config.DD_RUM_SAMPLE,
    version: process.env.IMAGE_RELEASE,
    trackViewsManually: true,
  })

  datadogRum.addRumGlobalContext('service', DD_SERVICE)
  datadogRum.addRumGlobalContext('env', app.$config.DD_ENV)
  datadogRum.addRumGlobalContext('tags.env', app.$config.DD_ENV)
  datadogRum.addRumGlobalContext('tags.continent', app.$config.DD_CONTINENT)
  datadogRum.addRumGlobalContext('tags.gtm', app.$config.GTM_ENV)
  datadogRum.addRumGlobalContext('country', store.getters['config/country'])
  datadogRum.addRumGlobalContext(
    'marketplace',
    store.getters['config/marketplace'],
  )

  // Use process.env (runtime on server, hardcoded at build-time on client) for
  // image tags.
  datadogRum.addRumGlobalContext('tags.release', process.env.IMAGE_RELEASE)
  datadogRum.addRumGlobalContext('tags.commit', process.env.IMAGE_COMMIT)

  app.router.afterEach(onRouteChange)
}
